
import useTileData from "@/hooks/tiles/useTileData";
import { createContext } from "react"

export interface ITileDataContext extends ReturnType<typeof useTileData> {
}

export const TileDataContext = createContext<ITileDataContext>({
    data: undefined,
    loading: false,
    validating: false,
    error: undefined,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined }
});

export default TileDataContext;